import { render, staticRenderFns } from "./InterForDashboardList.vue?vue&type=template&id=59d675c5&scoped=true&"
import script from "./InterForDashboardList.vue?vue&type=script&lang=js&"
export * from "./InterForDashboardList.vue?vue&type=script&lang=js&"
import style0 from "./InterForDashboardList.vue?vue&type=style&index=0&id=59d675c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d675c5",
  null
  
)

export default component.exports